import styled from "styled-components";

import { Button } from "shared/components/Button/Button";
import { space } from "shared/styles/constants";

export const StyledSearchFieldButton = styled(Button)`
  margin: ${space.xxs};
  height: ${space.xl};
  width: ${space.xl};

  padding: ${space.xs};
`;
